import { FeedbackState } from '../types/FeedbackState'

export const state: FeedbackState = {
  context: 'info',
  message: '',
  show: false,
  duration: 200
}
